import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { BUTTON_VARIANT_NEGATIVE, Button, Flex } from 'mailup-web-components'

const NotifySaveSegmentSuccess: FC = () => {
  const intl = useIntl()

  const handleClick = (): void => {
    window.open(
      'https://1eekadb36cd.typeform.com/segmenti',
      '_blank',
      'noreferrer,noopener',
    )
  }

  return (
    <Flex flexDirection="column" gap="16px">
      {intl.formatMessage({ id: 'Load.RecipientsList.SegmentSaveFakeSuccess' })}

      <Flex justifyContent="flex-start">
        <Button kind={BUTTON_VARIANT_NEGATIVE} onClick={handleClick}>
          {intl.formatMessage({
            id: 'Load.RecipientsList.SegmentSaveGiveReview',
          })}
        </Button>
      </Flex>
    </Flex>
  )
}

export default NotifySaveSegmentSuccess
